export const validation = {
  maxTitleCount: 100,
  maxParagraph: 300
}
